import React from 'react';
import { InputContainer } from '../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';

export const VentureLoginInfoComponent = ({ onInnerFormChange, selectedVenture }: any) => (
          <>
  <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
              label="Phone"
              name="Phone"
              isDisabled
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'Login.Phone',
                  selectedVenture?.Login
                )
              }}
              type="number"
              value={selectedVenture?.Login?.Phone}
          />
    
      <InputContainer
              label="Email"
              name="Email"
              isDisabled
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'Login.Email',
                  selectedVenture?.Login
                )
              }}
              type="text"
              value={selectedVenture?.Login?.Email}
          />
    </div>
 }
 expandedPanel="loginInfo"
 headerTitle="Login Info"
/>
</>
)
export default VentureLoginInfoComponent;
